import React from "react";

//Components
import Navbar from "../components/Navbar/Navbar";
import InsurancePartnerSection from "../components/PeopleHomeComponents/InsurancePartnerSection/InsurancePartnerSection";
import Footer from "../components/Footer/Footer";
import AuthorizationPersonalInformationSection from "../components/AuthorizationPersonalInformationSection/AuthorizationPersonalInformationSection";

const AuthorizationPersonalInformationScreen = () => {
  return (
    <>
      <Navbar />
      <AuthorizationPersonalInformationSection />
      <InsurancePartnerSection />
      <Footer />
    </>
  );
};

export default AuthorizationPersonalInformationScreen;
